import { Theme } from "@mui/material";

const Typography = (theme: Theme, fontFamily: string) => ({
  fontFamily,
  h6: {
    fontWeight: 500,
    color: theme.palette.grey[600],
    fontSize: "0.75rem"
  },
  h5: {
    fontSize: "0.875rem",
    color: theme.palette.grey[600],
    fontWeight: 500
  },
  h4: {
    fontSize: "1rem",
    color: theme.palette.grey[600],
    fontWeight: 600
  },
  h3: {
    fontSize: "1.25rem",
    color: theme.palette.grey[600],
    fontWeight: 600
  },
  h2: {
    fontSize: "1.5rem",
    color: theme.palette.grey[600],
    fontWeight: 700
  },
  h1: {
    fontSize: "2.125rem",
    color: theme.palette.grey[600],
    fontWeight: 700
  },
  subtitle1: {
    fontSize: "18px",
    fontWeight: "bold",
    color: theme.palette.warning.main
  },
  subtitle2: {
    fontSize: "1.25rem",
    color: theme.palette.text.secondary
  },
  caption: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    fontWeight: 400
  },
  body1: {
    fontSize: "0.8125rem",
    color: theme.palette.text.primary
  },
  body2: {
    fontSize: "0.8125rem",
    color: theme.palette.text.secondary
  },
  error: {
    fontSize: "0.8125rem",
    color: theme.palette.error.main
  },
  customInput: {
    marginTop: 1,
    marginBottom: 1,
    "& > label": {
      top: 23,
      left: 0,
      color: theme.palette.grey[500],
      '&[data-shrink="false"]': {
        top: 5
      }
    },
    "& > div > input": {
      padding: "30.5px 14px 11.5px !important"
    },
    "& legend": {
      display: "none"
    },
    "& fieldset": {
      top: 0
    }
  }
});

export default Typography;
